// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".box .name[data-v-481c1438] .el-autocomplete{display:block}.box .product[data-v-481c1438] .el-select{display:block;max-width:500px}.box .demo-dynamic[data-v-481c1438] .el-input{width:70%}.box .sumbit-btn[data-v-481c1438]{margin:0 auto;width:50px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
